import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "closeable", "compact", "onClose"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { FLINT, GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import UICloseButton from '../button/UICloseButton';
import { allSizes } from '../utils/propTypes/tshirtSize';
import { setBorderRadius, setDistance } from '../utils/Styles';
import { forwardRef } from 'react';
import { TileContextProvider, defaultTileContext } from '../context/TileContext';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const compactTileContext = {
  compact: true
};
const spacedMixin = css([".private-tile + &{margin-top:16px;}"]);
const Tile = styled.div.withConfig({
  displayName: "UITile__Tile",
  componentId: "sc-1osb7hm-0"
})(["position:relative;", ";background-color:", ";border:1px solid ", ";", ";", ""], setBorderRadius(), OLAF, GREAT_WHITE, ({
  distance
}) => distance && setDistance(distance), ({
  distance
}) => !distance && spacedMixin);
const CloseButton = styled(UICloseButton).withConfig({
  displayName: "UITile__CloseButton",
  componentId: "sc-1osb7hm-1"
})(["right:12px;top:12px;"]);
const UITile = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      className,
      closeable,
      compact,
      onClose
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(TileContextProvider, {
    value: compact ? compactTileContext : defaultTileContext,
    children: /*#__PURE__*/_jsxs(Tile, Object.assign({}, rest, {
      className: classNames('private-tile', className),
      ref: ref,
      children: [closeable ? /*#__PURE__*/_jsx(CloseButton, {
        color: FLINT,
        onClick: onClose,
        size: "sm"
      }) : null, children]
    }))
  });
});
UITile.displayName = 'UITile';
UITile.propTypes = {
  children: PropTypes.node.isRequired,
  closeable: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  distance: PropTypes.oneOfType([allSizes, PropTypes.oneOf(['flush'])]),
  onClose: PropTypes.func
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UITile.defaultProps = {
  closeable: false,
  compact: false
};
export default UITile;